import { PREVIOUS_PERIOD_SUFFIX } from '../types/shared-types'

export const validateFieldName = (fieldName: string) => {
  if (!fieldName) return 'Field name is required'
  if (_.endsWith(fieldName, PREVIOUS_PERIOD_SUFFIX)) return 'Field name cannot end with __prev'
  return ''
}
